<template>
  <User />
</template>

<script>
import User from './user/Users.vue'
export default {
  components: {
    User
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/AgentManage.vue